import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { CrmUsersService } from '../pages/crm-users/crm-users.service';
import { takeUntil } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class RoleService {
	currUser: any;
	private messageSource = new BehaviorSubject('default message');
	currentMessage = this.messageSource.asObservable();
	// private messageSourcemenu = new BehaviorSubject('default message');
	// currentMessagemenu = this.messageSourcemenu.asObservable();
	private _unsubscribeAll: Subject<any>;
	crmUser;
	constructor(
		private _crmUsersService: CrmUsersService,
	) { }

	changeMessage(message: any = null, sub_message: any = null) {
		this.currUser = JSON.parse(localStorage.getItem('user'));
		if (this.currUser.permissions.length > 0) {
			for (let i = 0; i < this.currUser.permissions.length; i++) {
				if (this.currUser.permissions[i].module == message) {
					for (let n = 0; n < this.currUser.permissions[i].sub_module.length; n++) {
						if (this.currUser.permissions[i].sub_module[n].module == sub_message) {

							message = this.currUser.permissions[i].sub_module[n].permissions
						}
					}
				}
			}
		}

		this.messageSource.next(message)

	}
	// changeMenu() {

	//   this.crmUser=JSON.parse(localStorage.getItem('user'));

	// 	// console.log("function call ho user of web",this.crmUser)
	// 	// 			console.log("function call ho chuka ha",this.menu)
	//  const permission=this.crmUser.permissions			
	// 	for(let i=0;i<permission.length;i++){
	//         if(permission[i].sub_module){
	// 	// console.log("1st if run")

	//          for(let n=0;n<permission[i].sub_module.length;n++){
	// 		   if(permission[i].sub_module[n].permissions.create==false && permission[i].sub_module[n].permissions.read==false && permission[i].sub_module[n].permissions.edit==false){
	// 	// console.log("2st if run")

	// 			for(let m=0;m<this.menu.length;m++){
	// 				   if(this.menu[m].title.toLowerCase()==permission[i].module){
	// 	// console.log("3st if run")

	// 					if(this.menu[m].children){
	// 	// console.log("4st if run")

	//                          for(let s=0;s<this.menu[m].children.length;s++){
	// 						   if(this.menu[m].children[s].title.toLowerCase()==permission[i].sub_module[n].module){
	// 	// console.log("5st if run")

	// 							// delete this.menu[this.crmUser.user_role];
	// 							for( var r = 0; r < this.menu[m].children[s].role.length; r++){ 
	// 								if ( this.menu[m].children[s].role[r] === this.crmUser.user_role) 
	// 								{ 

	// 									this.menu[m].children[s].role.splice(r, 1);
	// 								 }
	// 								}
	// 						// delete this.menu[m].children[s].role[this.crmUser.user_role];
	// 						console.log("function call ho chuka ha menu",this.menu)

	// 						   }
	// 					   }
	// 					   }else{
	// 	// console.log("else run")
	// 	for( var r = 0; r < this.menu[m].role.length; r++){ 
	// 		if ( this.menu[m].role[r] === this.crmUser.user_role) 
	// 		{ 
	// 			this.menu[m].role.splice(r, 1);
	// 		 }
	// 		}
	// 						// delete this.menu[m].role[this.crmUser.user_role];
	// 					   }
	// 				   }
	// 			   }
	// 		   }
	// 	   }
	// 	  }
	// 	}



	//   this.messageSourcemenu.next(this.menu)

	// }
}
